import { render, staticRenderFns } from "./sysSetting.vue?vue&type=template&id=74b8a338&"
import script from "./sysSetting.vue?vue&type=script&lang=js&"
export * from "./sysSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports